import { render } from "./PopupInfo.vue?vue&type=template&id=5e6d830f"
import script from "./PopupInfo.vue?vue&type=script&lang=js"
export * from "./PopupInfo.vue?vue&type=script&lang=js"

import "./PopupInfo.vue?vue&type=style&index=0&id=5e6d830f&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__